define('gumbo-js-client-lib/forms/gameData/PreviewWrapForm',{
	dataDirectory: null,
	away: {
		preview: null,
		recap: null
	},
	home: {
		preview: null,
		recap: null
	},
	photos: null,
	preview: null,
	wrap: null,
	tvStation: null,
	media: {
		free: null,
		title: null,
		thumbnail: null,
		start: null,
		mlbtv: null,
		type: null
	}
});
